export default "__VITE_ASSET__JSHJmWHF__"